
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stayhousedbayarea",
      function () {
        return require("private-next-pages/stayhousedbayarea/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stayhousedbayarea"])
      });
    }
  